import navbar from "./navbar.json";
import header from "./header.json";

export const navFR = {
	header,
	navbar,
};
